export default __webpack_public_path__ + "static/media/gif.cfe45277.gif";